<template>
  <div class="title-attraction">
    More about fondi
    <div class="title-text-sm">{{ $t('lp.app-more') }}</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.title-attraction {
  background-image: url('/img/lp/lpFrmSectionTitle.png');
  background-size: cover;
  background-position: center bottom;
  padding: 16px 0;
  font-size: 40px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  line-height: 1em;
}
.title-attraction .title-text-sm {
  font-size: 20px;
  line-height: 1.1em;
}
@media (max-width: 767px) {
  .title-attraction {
    font-size: 20px;
    line-height: 1.5em;
    padding: 2px 0 8px;
  }
  .title-attraction .title-text-sm {
    font-size: 10px;
  }
}
</style>
